import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Grid, IconButton, makeStyles, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import CssBaseline from '@material-ui/core/CssBaseline';
import AdminTopbar from './AdminTopbar';
import { Add, ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import AdminFooter from './AdminFooter';
import axiosInstance, { readFile, WEB_API } from '../common/Constants';
import DeleteIcon from '@material-ui/icons/Delete';

const setCreatedAt = (createdAt, format) => {
  if (!(createdAt > 0)) return '-';

  const dt = new Date(Number(createdAt));
  const addDt =
    dt.getFullYear() +
    format +
    `00${(dt.getMonth() + 1).toString()}`.slice(-2) +
    format +
    `00${dt.getDate().toString()}`.slice(-2) +
    format +
    `00${dt.getHours().toString()}`.slice(-2) +
    { format } +
    `00${dt.getMinutes().toString()}`.slice(-2);

  return addDt.slice(0, 10);
};

const LIMIT_SIZE = 3;

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
}));

const ProjectListPage = (props) => {
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [selectFilter, setSelectFilter] = useState('all');

  let cols = [
    {
      name: 'logo',
      label: 'Logo',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <img src={value.path} alt={value.name} style={{ width: '100px' }} />;
        },
      },
    },
    {
      name: 'title',
      label: 'Title',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'memo',
      label: 'Description',
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: 'category',
      label: 'Category',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'createdAt',
      label: '최초작성일',
      options: {
        filter: false,
        sort: true,

        customBodyRender: (value) => {
          return value && <div>{setCreatedAt(value, '/')}</div>;
        },
      },
    },

    {
      name: 'sortOrder',
      label: '순서',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return value && <div>{value}</div>;
        },
      },
    },
    {
      name: 'id',
      label: '순서변경',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <IconButton aria-label="down" size="small" onClick={() => handleOrder('down', value, tableMeta)}>
                <ArrowDropDown />
              </IconButton>
              <IconButton aria-label="up" size="small" onClick={() => handleOrder('up', value, tableMeta)}>
                <ArrowDropUp />
              </IconButton>
            </div>
          );
        },
      },
    },
    {
      name: 'id',
      label: '삭제',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <IconButton aria-label="delete" size="small" onClick={() => setDeleteAction(value, tableMeta)}>
              <DeleteIcon />
            </IconButton>
          );
        },
      },
    },
  ];

  const handleOrder = (type, value, meta) => {
    const item = data[meta.rowIndex];
    const param = {};
    if (type === 'up') {
      if (meta.rowIndex > 0) {
        param['referId'] = data[meta.rowIndex - 1].id;
        param['referOrder'] = item.sortOrder.substr(0, 1) + Number(item.sortOrder.substr(1));
        param['targetId'] = item.id;
        param['targetOrder'] = item.sortOrder.substr(0, 1) + (Number(item.sortOrder.substr(1)) - 1);
      }
    } else {
      // down
      if (meta.rowIndex < data.length - 1) {
        param['referId'] = data[meta.rowIndex + 1].id;
        param['referOrder'] = item.sortOrder.substr(0, 1) + Number(item.sortOrder.substr(1));
        param['targetId'] = item.id;
        param['targetOrder'] = item.sortOrder.substr(0, 1) + (Number(item.sortOrder.substr(1)) + 1);
      }
    }
    if (param.targetId) {
      axiosInstance.put(`${WEB_API}/home/project/sortOrder`, param).then(() => {
        swal('', '게시물 순번이 변경되었습니다.', 'info');
        setSelectFilter('all');
        getUserData();
      });
    }
  };

  const setDeleteAction = (value, meta) => {
    swal({
      title: '정말 삭제하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.delete(`${WEB_API}/home/project?projectId=${data[meta.rowIndex].id}`).then((data) => {
          swal('', '게시물이 삭제되었습니다.', 'info');
          setSelectFilter('all');
          getUserData();
        });
      }
    });
  };

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else {
      const newData = alldata.filter((d) => {
        return d.category === _filter;
      });
      setData(newData);
    }
  };

  const addProject = (id, cate, title, desc, logo, order) => {
    swal(
      <div>
        <h1>Poster {cate ? '수정' : '추가'}</h1>
        <select
          id={'sel-cate'}
          value={cate ? cate : selectFilter && selectFilter !== 'all' ? selectFilter : ''}
          style={{ padding: '16px', width: '100%', margin: '24px 0px' }}
          onChange={() => console.log('')}
        >
          <option value={''}>{'Category'}</option>
          <option value={'Pharmaceutical'}>{'Pharmaceutical'}</option>
          <option value={'MedicalSociety'}>{'MedicalSociety'}</option>
          <option value={'NoneMedical'}>{'NoneMedical'}</option>
          <option value={'CreativeDesign'}>{'CreativeDesign'}</option>
        </select>
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px', fontWeight: 'bold' }}>Title</p>
        <TextField id={'input-title'} margin="dense" fullWidth value={title || ''} />
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px', fontWeight: 'bold' }}>Description</p>
        <TextField
          id={'input-desc'}
          margin="dense"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          placeholder={
            '6줄 이상 작성 시 사용자 화면에서 텍스트가 잘릴 수 있습니다. (모바일 환경에서는 2줄 이상 작성 시 텍스트가 잘릴 수 있습니다.)'
          }
          value={desc || ''}
          style={{ width: '18em' }}
        />
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px', fontWeight: 'bold' }}>Logo</p>
        <input id="logo" type="file" style={{ width: '100%' }} />
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px' }}>{logo}</p>
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px', fontWeight: 'bold' }}>Order</p>

        {!cate && <div style={{ color: '#f00' }}>* 신규등록 시에는 카테고리를 확인해 주시기 바랍니다.</div>}
        <div style={{ color: '#f00' }}>* 숫자가 클수록 최신 게시물로 표시됩니다.</div>
        <TextField
          inputProps={{ inputMode: 'numeric', min: 0 }}
          id={'input-order'}
          type="number"
          margin="dense"
          fullWidth
          placeholder={'+ - 없이 숫자만 입력'}
          value={(order && Number(order.substr(1))) || ''}
        />
      </div>,
    ).then((isOK) => {
      if (isOK) {
        if (document.getElementById('logo').files.length > 0) {
          readFile(document.getElementById('logo').files[0], LIMIT_SIZE)
            .then(() => {
              if (id) uploadProject('imgUpload', id);
              else uploadProject('imgUpload');
            })
            .catch(() => {
              swal('', `${LIMIT_SIZE}MB를 초과하는 파일은 업로드할 수 없습니다.`, 'error');
            });
        } else if (logo) {
          uploadProject('', id);
        }
      }
    });
  };

  const uploadProject = (status, id) => {
    let cateStr =
      document.getElementById('sel-cate').value === 'Pharmaceutical'
        ? 'A'
        : document.getElementById('sel-cate').value === 'MedicalSociety'
        ? 'B'
        : document.getElementById('sel-cate').value === 'NoneMedical'
        ? 'C'
        : 'D';
    let formdata = new FormData();
    formdata.append('title', document.getElementById('input-title').value);
    formdata.append('memo', document.getElementById('input-desc').value);
    formdata.append('category', document.getElementById('sel-cate').value);
    formdata.append('sortOrder', cateStr + Number(document.getElementById('input-order').value));
    if (status && status === 'imgUpload') {
      formdata.append('logo', document.getElementById('logo').files[0]);
    }
    if (id) {
      formdata.append('projectId', id);
      axiosInstance.put(`${WEB_API}/home/project`, formdata).then(() => {
        swal('', '수정이 완료되었습니다.', 'success');
        setSelectFilter('all');
        getUserData();
      });
    } else {
      axiosInstance.post(`${WEB_API}/home/project`, formdata).then(() => {
        swal('', '등록이 완료되었습니다.', 'success');
        setSelectFilter('all');
        getUserData();
      });
    }
  };

  const rowClick = (_data, row) => {
    if (row.colIndex < 6) {
      const item = data[row.dataIndex];
      addProject(item.id, item.category, item.title, item.memo, item.logo.name, item.sortOrder);
    } else if (row.colIndex === 7) {
      setDeleteAction(_data, row);
    }
  };

  const options = {
    print: false,
    filterType: 'checkbox',
    viewColumns: false,
    download: false,
    searchOpen: false,
    selectableRows: 'none',
    onCellClick: rowClick,
  };

  const getUserData = () => {
    axiosInstance.get(`${WEB_API}/home/project/list`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      const sort = response.data.Items.sort(function (a, b) {
        let aCate = a.sortOrder.substr(0, 1);
        let bCate = b.sortOrder.substr(0, 1);
        let aOrder = Number(a.sortOrder.substr(1));
        let bOrder = Number(b.sortOrder.substr(1));
        if (aCate < bCate) return -1;
        if (aCate > bCate) return 1;
        // [수정 231211] 게시물 최신순(index 숫자 큰순)
        if (bOrder < aOrder) return -1;
        if (bOrder > aOrder) return 1;

        return 0;
      });
      setData(sort);
      setAllData(sort);
    });
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={1} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justify={'space-between'} alignItems={'center'}>
            <Grid item>
              <h1>Projects</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All
                </Button>
                <Button
                  variant={selectFilter === 'Pharmaceutical' ? 'contained' : 'outlined'}
                  onClick={() => handleFilter('Pharmaceutical')}
                >
                  Pharmaceutical
                </Button>
                <Button
                  variant={selectFilter === 'MedicalSociety' ? 'contained' : 'outlined'}
                  onClick={() => handleFilter('MedicalSociety')}
                >
                  Medical Society
                </Button>
                <Button variant={selectFilter === 'NoneMedical' ? 'contained' : 'outlined'} onClick={() => handleFilter('NoneMedical')}>
                  None Medical
                </Button>
                <Button
                  variant={selectFilter === 'CreativeDesign' ? 'contained' : 'outlined'}
                  onClick={() => handleFilter('CreativeDesign')}
                >
                  Creative Design
                </Button>
              </ButtonGroup>
            </Grid>
            <Grid item style={{ flex: 1 }}>
              &nbsp;
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={() => addProject()} startIcon={<Add />}>
                New Project
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: 20 }}>
          <MUIDataTable title={''} data={data} columns={cols} options={options} />
        </Grid>
      </Grid>
      <AdminFooter />
    </Grid>
  );
};

export default ProjectListPage;
